import DefaultApiService from "./default";

const BASE = "SLN/Contractor/ContractorEquipmentCatalog";

const wrap = (res, fallback) => ({
  ok: res?.isSuccess !== false && res?.IsSuccess !== false,
  message: res?.message || res?.Message || "",
  data: res?.data ?? res?.Data ?? fallback,
});

const ContractorEquipmentCatalogApi = {
  getMyItemRequests: async () =>
    wrap(await DefaultApiService.getCustomeApi(`${BASE}/GetMyItemRequests`), []),

  submitNewEquipmentRequest: async (payload) =>
    wrap(
      await DefaultApiService.postApi(`${BASE}/SubmitNewEquipmentRequest`, payload)
    ),
};

export default ContractorEquipmentCatalogApi;
